// ローディング判定
jQuery(window).on("load", function() {
  jQuery("body").attr("data-loading", "true");
});

jQuery(function() {
  // スクロール判定
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (400 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }
  });

  /*   if (window.matchMedia("(max-width: 750px)").matches) { */
  /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
  jQuery(".g-nav-item-link.child").on("click", function(e) {
    let drawer = jQuery(".js-drawer");
    let targetClass = jQuery(drawer).attr("data-target");
    let ariaControls = jQuery(drawer).attr("aria-controls");

    jQuery("." + targetClass).toggleClass("is-checked");
    jQuery(body).toggleClass("is-checked");
    if (jQuery("#" + ariaControls).attr("aria-hidden") === "true") {
      jQuery("#" + ariaControls).attr("aria-hidden", "false");
    } else {
      jQuery("#" + ariaControls).attr("aria-hidden", "ture");
    }

    if (jQuery(drawer).attr("aria-expanded") === "true") {
      jQuery(drawer).attr("aria-expanded", "false");
    } else {
      jQuery(drawer).attr("aria-expanded", "ture");
    }

    jQuery(this).toggleClass("active");
    jQuery(this)
      .closest(".menu-second")
      .slideToggle();
    jQuery(this)
      .not(jQuery(this).closest(".g-nav-item.child"))
      .children(".menu-second")
      .slideUp();
    jQuery(this)
      .not(jQuery(this).hasClass(".active"))
      .toggleClass("active");
  });
  /*   } */

  /* ドロワー */
  jQuery(".js-drawer").on("click", function(e) {
    e.preventDefault();
    let targetClass = jQuery(this).attr("data-target");
    let ariaControls = jQuery(this).attr("aria-controls");
    jQuery("." + targetClass).toggleClass("is-checked");
    jQuery(body).toggleClass("is-checked");

    if (jQuery("#" + ariaControls).attr("aria-hidden") === "true") {
      jQuery("#" + ariaControls).attr("aria-hidden", "false");
    } else {
      jQuery("#" + ariaControls).attr("aria-hidden", "ture");
    }

    if (jQuery(this).attr("aria-expanded") === "true") {
      jQuery(this).attr("aria-expanded", "false");
    } else {
      jQuery(this).attr("aria-expanded", "ture");
    }
    return false;
  });

  jQuery(".sp-btn").on("click", function() {
    jQuery(this)
      .next()
      .slideToggle();
  });
});

var urlHash = location.hash;
if (urlHash) {
  jQuery("body,html")
    .stop()
    .scrollTop(0);

  setTimeout(function() {
    var target = jQuery(urlHash);
    var position = target.offset().top - 120;
    //ランダムっぽいのでどちらにも対応
    jQuery("body,html")
      .stop()
      .animate({ scrollTop: position }, 300);
  }, 100);
}

jQuery('a[href^="#"]:not(.no_somooth)').click(function() {
  let id = jQuery(this).attr("href");
  let speed = 300;
  let target = jQuery("#" == id ? "html" : id);
  let position = jQuery(target).offset().top - 140;
  if ("fixed" !== jQuery("header").css("position")) {
    position = jQuery(target).offset().top;
  }

  console.log("ok");

  jQuery("html, body").animate(
    {
      scrollTop: position
    },
    speed
  );
  return false;
});

jQuery(function() {
  // aimation呼び出し
  if (jQuery(".js-scroll-trigger").length) {
    scrollAnimation();
  }

  // aimation関数
  function scrollAnimation() {
    jQuery(window).scroll(function() {
      jQuery(".js-scroll-trigger").each(function() {
        let position = jQuery(this).offset().top,
          scroll = jQuery(window).scrollTop(),
          windowHeight = jQuery(window).height();

        if (scroll > position - windowHeight + 200) {
          jQuery(this).addClass("active");
        }
      });
    });
  }
  jQuery(window).trigger("scroll");
});

//wait
jQuery(function() {
  "use waits";

  var dialog = document.getElementById("dialog");
  var waits = document.getElementsByClassName("js-wait");
  var cancel = document.getElementById("cancel");
  var scrollpos;

  if (waits) {
    for (let i = 0; i < waits.length; i++) {
      waits[i].addEventListener(
        "click",
        function() {
          dialog.style.visibility = "visible";
          dialog.style.opacity = 1;
          //scrollpos = jQuery(window).scrollTop();
          jQuery("body").addClass("fixed");
          //.css({ overflow: hidden });
        },
        false
      );
    }

    cancel.addEventListener("click", function() {
      jQuery("body").removeClass("fixed");
      //.css({ overflow: auto });
      //window.scrollTo(0, scrollpos);
      dialog.style.visibility = "hidden";
      dialog.style.opacity = 0;
    });
  }
});

//headerスクロール fix
jQuery(window).on("scroll", function() {
  jQuery("header").css("left", -jQuery(window).scrollLeft());
});

if (window.matchMedia("(min-width: 769px)").matches) {
  /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
}
var _window = jQuery(window),
  _header = jQuery("header"),
  heroBottom;

_window.on("scroll", function() {
  /*         heroBottom1 = jQuery(".mv").height();
  heroBottom2 = jQuery(".header-logo").height();
  heroBottom = heroBottom1 - heroBottom2; */
  if (_window.scrollTop() > 20) {
    _header.addClass("transform");
  } else {
    _header.removeClass("transform");
  }
});
_window.trigger("scroll");

var urlHash = location.hash;
if (urlHash) {
  jQuery("body,html")
    .stop()
    .scrollTop(0);

  setTimeout(function() {
    var target = jQuery(urlHash);
    var position = target.offset().top - 120;
    //ランダムっぽいのでどちらにも対応
    jQuery("body,html")
      .stop()
      .animate({ scrollTop: position }, 300);
    console.log(header);
    console.log(position);
  }, 100);
}

// アコーディオンメニュー
jQuery(".g-nav-item.child").on("click", function() {
  /*     if (window.matchMedia("(max-width: 750px)").matches) { */
  jQuery(this)
    .children(".g-nav-item-link")
    .toggleClass("active");
  jQuery(this)
    .children(".menu-second")
    .slideToggle();
  jQuery(".g-nav-item.child")
    .not(jQuery(this))
    .children(".menu-second")
    .slideUp();
  jQuery(".g-nav-item.child")
    .not(jQuery(this))
    .children(".g-nav-item-link")
    .removeClass("active");
  /*     } */
});

jQuery(document).ready(function() {
  if (window.matchMedia("(max-width: 750px)").matches) {
    let floatingHeight = jQuery(".floating").outerHeight();
    jQuery("footer").css("margin-bottom", floatingHeight);
  }
  /*   jQuery(".floating").hide(); //ボタンを非表示にする 
    jQuery(window).on("scroll", function() {
    if (window.matchMedia("(max-width: 750px)").matches) {
      let scrollTop = jQuery(window).scrollTop(); // スクロール上部の位置
      let headerHeight = jQuery("header").innerHeight();
      let floatingHeight = jQuery(".floating").outerHeight();
      jQuery("footer").css("margin-bottom", floatingHeight);
      /*       let areaTop =
        jQuery(".main section:nth-of-type(2)").offset().top - headerHeight; // 対象エリアの上部の位置
      let areaBottom = areaTop + jQuery("main").innerHeight();
      if (scrollTop > areaTop && scrollTop < areaBottom) {
        jQuery(".floating").fadeIn(); //ボタンがフェードインする
      } else {
        jQuery(".floating").fadeOut(); //ボタンがフェードアウトする
      } 
    }
    scrollHeight = jQuery(document).height(); //ドキュメントの高さ
    scrollPosition = jQuery(window).height() + jQuery(window).scrollTop(); //現在地
    footHeight = jQuery("footer").outerHeight(true); //止めたい位置の高さ(今回はfooter)
    stopHeight = footHeight;

    if (window.matchMedia("(min-width: 751px)").matches) {
      if (scrollHeight - scrollPosition <= stopHeight) {
        //ドキュメントの高さと現在地の差がfooterの高さ以下の時
        jQuery(".floating").css({
          position: "absolute" //pisitionをabsoluteに変更
        });
      } else {
        //それ以外の場合は
        jQuery(".floating").css({
          position: "fixed" //固定表示
        });
      }
    }

    scrollHeight = jQuery(document).height(); //ドキュメントの高さ
    scrollPosition = jQuery(window).height() + jQuery(window).scrollTop(); //現在地
    footHeight = jQuery("footer").innerHeight(); //止めたい位置の高さ(今回はfooter)
    stopHeight = footHeight; 
  }); */
});

// 初期表示時の文字色変更
jQuery(window).on("load", function() {
  jQuery.each(jQuery("input[type=date]"), (index, datebox) => {
    datebox.style.color = datebox.value ? "black" : "white";
  });
});

jQuery(function() {
  // フォーカス取得時は入力用にいったん色を付ける
  jQuery("input[type=date]").focus(function(event) {
    this.style.color = "black";
  });

  // フォーカス喪失後の文字色変更
  jQuery("input[type=date]").blur(function(event) {
    this.style.color = this.value ? "black" : "white";
  });
});
